import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { getDossierIdFromOpportunityId } from "../../api/dossier/getDossierIdFromOpportunityId";
import { PageDirectoryEntryName } from "../../api/PageDirectory";
import PageContainer from "../../components/PageContainer";
import { useAuth } from "../../providers/AuthProvider";

const ALLOWED_DESTINATIONS = ["viewDossier", "viewDossierFromStatus"];

const RedirectOpportunityToDossier = () => {
  const [searchParams] = useSearchParams();
  const { opportunityId } = useParams();

  const destination = searchParams.get("destination") as PageDirectoryEntryName;
  const _destination =
    destination && ALLOWED_DESTINATIONS.includes(destination)
      ? destination
      : "viewDossier";

  const { getScopedPageUrl } = useAuth();

  if (!opportunityId) {
    // TODO: improve client side error messaging
    throw new Error("opportunity id param is missing");
  }

  const dossierId = getDossierIdFromOpportunityId(opportunityId);

  if (dossierId.isError) {
    throw dossierId.error;
  }

  return (
    <PageContainer loading={dossierId.isLoading}>
      {dossierId.isSuccess && (
        <Navigate to={getScopedPageUrl(_destination, dossierId.data)} />
      )}
    </PageContainer>
  );
};

export default RedirectOpportunityToDossier;
